module.exports = __webpack_public_path__ + "static/media/ArrowLongWhite.053a07a7.svg";